<market-main-layout>
  <div
    class="no-scrollbar max-w-[480px] grow overflow-y-auto bg-base-200 pt-[64px]">
    <market-intersect-observable [minHeight]="bannerHeight">
      <ng-template marketTemplateMarker>
        <market-carousel-banner></market-carousel-banner>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="172px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-nutriday-admin />
        </div>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="172px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-nutridayshop />
        </div>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="172px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-categories />
        </div>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="316px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-product [title]="'FlashSale'" [flashSale]="true">
            <market-flash-sale-icon title></market-flash-sale-icon>
          </market-carousel-product>
        </div>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="316px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-product
            [title]="'Sản phẩm nổi bật'"
            [queryType]="PRODUCT_TYPE.nutriShop"></market-carousel-product>
        </div>
      </ng-template>
    </market-intersect-observable>
    <market-intersect-observable minHeight="316px">
      <ng-template marketTemplateMarker>
        <div class="px-1">
          <market-carousel-product
            [title]="'Săn quà ưu đãi'"
            [queryType]="PRODUCT_TYPE.sale"></market-carousel-product>
        </div>
      </ng-template>
    </market-intersect-observable>
  </div>
</market-main-layout>
